import {Pipe, PipeTransform} from "@angular/core";
import {utcToZonedTime} from 'date-fns-tz';

@Pipe({name: 'relativeTime'})
export class RelativeTimePipe implements PipeTransform {
    transform(value: Date | number | string, prefix: boolean = true): string {
        console.log('Fecha ', value);
        if (typeof value === 'string') {
            value = new Date(value);
        } else if (typeof value === 'number') {
            value = new Date(value); // Asegúrate de convertir el número a Date
        }

        // Verifica si el valor es una fecha válida
        if (!(value instanceof Date) || isNaN(value.getTime())) {
            console.log('Fecha inválida', value);
            return 'Fecha inválida';
        }

        const santiagoDate = utcToZonedTime(value, 'America/Santiago');
        const seconds: number = Math.floor(((new Date()).getTime() - santiagoDate.getTime()) / 1000);
        let interval: number;

        interval = Math.floor(seconds / 31536000);
        if (interval > 1) {
            return (prefix? "Hace ":'') + interval + " años";
        }
        interval = Math.floor(seconds / 2592000);
        if (interval > 1) {
            return (prefix? "Hace ":'') + interval + " meses";
        }
        interval = Math.floor(seconds / 86400);
        if (interval > 1) {
            return (prefix? "Hace ":'') + interval + " días";
        }
        interval = Math.floor(seconds / 3600);
        if (interval > 1) {
            return (prefix? "Hace ":'') + interval + " horas";
        }
        interval = Math.floor(seconds / 60);
        if (interval > 1) {
            return (prefix? "Hace ":'') + interval + " minutos";
        }
        return (prefix? "Hace ":'') + Math.floor(seconds) + " segundos";
    }
}